import type { GenderId, LangCode } from '@/lib/baba-api'

export const DEFAULT_SOURCE: LangCode = 'en'
export const DEFAULT_TARGET: LangCode = 'he'
export const PREFS_KEY = 'baba.app.prefs.v1'
export const DRAFT_KEY = 'baba.app.draft.v1'
export const RECENT_TRANSLATIONS_KEY = 'baba.app.recent_translations.v2'
export const RECENT_MAX = 12
export const EXAMPLE_PHRASES = ['Shalom, how are you?', "I'd love to meet for coffee", 'Toda raba, achi']

/** "Speaking to" audience — Title Case labels for the command palette. */
export const SPEAKING_TO_OPTIONS: { id: GenderId; label: string }[] = [
  { id: 'general', label: 'Auto' },
  { id: 'to_male', label: 'A Man' },
  { id: 'to_female', label: 'A Woman' },
  { id: 'to_mixed_group', label: 'A Group, Mixed' },
  { id: 'to_male_group', label: 'A Group, Mostly Men' },
  { id: 'to_female_group', label: 'A Group, Mostly Women' },
]

/** Set by TranslatorPage when a landing hand-off carried text; Translator consumes it once and runs the translation. */
export const HANDOFF_AUTOTRANSLATE_KEY = 'baba.app.handoff_autotranslate'
